import styled from 'styled-components';

const VSpacer = styled.div`
  width: ${props => props.width || '20px'};
`;
 
export default VSpacer;